import {
  RiDashboardLine,
  RiBarChartLine,
  RiCheckboxMultipleLine,
  RiFileList2Line,
  RiLockPasswordLine,
  RiSettings3Line,
} from "react-icons/ri";

const options = [
  {
    groupLabel: "OVERVIEW",
    items: [
      {
        key: "newDashboard",
        label: "sidebar.Dashboard",
        iconComponent: RiDashboardLine,
      },
    ],
  },
  {
    groupLabel: "RESPOND",
    items: [
      {
        key: "tiering-assessments",
        label: "sidebar.TieringAssessments",
        iconComponent: RiBarChartLine,
      },
      {
        key: "assessments",
        label: "sidebar.Assessments",
        iconComponent: RiCheckboxMultipleLine,
      },
      {
        key: "TermsAndConditionMaster",
        label: "sidebar.DocumentRequests",
        iconComponent: RiFileList2Line,
      },
    ],
  },
  // {
  //   groupLabel: "ACCOUNT",
  //   items: [
  //     {
  //       key: "changePIN",
  //       label: "sidebar.ChangePIN",
  //       iconComponent: RiLockPasswordLine,
  //     },
  //     {
  //       key: "Profile",
  //       label: "sidebar.Settings",
  //       iconComponent: RiSettings3Line,
  //     },
  //   ],
  // },
];

export default options;
